import { FormControl, Box, FormGroup } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { ImagePicker } from '~/components/common/ImagePicker'
import { CAMPAIGN_ERROR_MESSAGE, CAMPAIGN_FORM_TITLE } from '~/constants/campaign'
import { ImageListType } from 'react-images-uploading'
import { CampaignInputComponent, CampaignInputComponentProps } from './CampaignInputComponent'
import { ReviewSection, ReviewTarget, FormatVersion } from '~/generated/graphql'
import { z } from 'zod'
import { ValidationErrorMessage } from '~/components/common/ValidationErrorMessage'
import { useEffect, useRef } from 'react'

export const campaignImageSchemaFields = {
  coverImages: z
    .array(z.any())
    .min(1, CAMPAIGN_ERROR_MESSAGE.REQUIRED)
    .transform((v) => {
      return v as ImageListType
    }),
}
export const campaignImageSchema = z.object(campaignImageSchemaFields)

type Props = CampaignInputComponentProps

export const CampaignImage = ({ description, tooltip }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<z.infer<typeof campaignImageSchema>>()
  const inputRef = useRef<HTMLElement>(null)
  useEffect(() => {
    if (errors.coverImages) {
      inputRef.current?.scrollIntoView()
    }
  }, [errors])
  return (
    <CampaignInputComponent
      title={`${CAMPAIGN_FORM_TITLE.image}(最大３枚)`}
      required={true}
      description={description}
      tooltip={tooltip}
      review={{
        section: ReviewSection.Campaign,
        targets: [ReviewTarget.CoverImages, ReviewTarget.LegalCoverImages],
      }}
      compatibleFormatVersions={[FormatVersion.V4Campaign]}
    >
      <Controller
        name="coverImages"
        control={control}
        render={({ field: { ref: _, ...field }, fieldState: { error } }) => {
          return (
            <FormGroup ref={inputRef}>
              <FormControl fullWidth component="fieldset">
                <Box sx={{ mt: 1 }}>
                  <ImagePicker multiple value={field.value} onChange={field.onChange} maxNumber={3} />
                </Box>
                <ValidationErrorMessage sx={{ mt: 4 }} error={error?.message} />
              </FormControl>
            </FormGroup>
          )
        }}
      />
    </CampaignInputComponent>
  )
}
